
/**
 * `SimpleTeaser` - Simple Teaser Component.
 * This is the wrapper component- This component uses workbench wb-content-slider.
 * {@link https://wb2.oneweb.mercedes-benz.com/developer/web-components/content-slider}
 * This component accepts a datajson as attribute to change the theme between light and dark {theme: 'light' | 'dark'}
 * As slot, SimpleTeaser uses SimpleTeaserItem (owc-simple-teaser-item) which will be the slide for the wb-content-slider.
 * SimpleTeaserItem should always have the classes:
 * - wb-grid-col-mq6-3 wb-grid-col-mq4-4 wb-grid-col-mq3-6 wb-grid-col-mq1-12 owc-wb-grid-col-mq-2-3-midpoint
 * - owc-simple-teaser-item
 * - wb-content-slider__item
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { SimpleTeaserComponent } from '@owc-packages/SimpleTeaser/src/SimpleTeaser';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import Footnotes from '@owc-packages/Footnotes/src/Footnotes.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import { setUpWbSlider } from '@owc-utils/Workbench/slider-utils';

const sliderClasses = [
  'wb-slider__item',
  'wb-grid-col-mq6-3',
  'wb-grid-col-mq4-4',
  'wb-grid-col-mq3-6',
  'wb-grid-col-mq1-12',
  'owc-wb-grid-col-mq-2-3-midpoint',
];

export default (ComponentInitializeDispatcher as SimpleTeaserComponent).extend({
  name: 'owc-simple-teaser',
  components: {
    SlotContainer,
    Footnotes,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent, Personalisation],
  mounted() {
    const slider = this.$refs.wbSlider as HTMLTemplateElement;

    setUpWbSlider(slider, sliderClasses);

    this.shouldShowMedia = true;
  },
  data() {
    return {
      shouldShowMedia: false,
    };
  },
  computed: {
    isDarkMode: function() {
      return Boolean(this.personaliseableData.darkMode);
    },
    theme: function() {
      return this.isDarkMode ? 'dark' : 'light';
    },
    footnotes() {
      if (this.personaliseableData.footnotes) {
        return {
          footnotes: this.personaliseableData.footnotes,
          darkMode: this.personaliseableData.darkMode,
        };
      }

      return;
    },
  },
});
